import React from 'react'

import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import ReactPlayer from 'react-player'
import { useDispatch } from 'react-redux'

import { setVideoPlaying } from '@/redux/ui/uiSlice'

interface IncidentNoteVideoPlayerIProps {
  height?: string | number
  play?: boolean
  videoUrl: string
  width?: string | number
}

export const IncidentNoteVideoPlayer = ({
  height = '100%',
  play = false,
  videoUrl,
  width = '100%',
}: IncidentNoteVideoPlayerIProps) => {
  const dispatch = useDispatch()
  const isDownloadEnabled = useFeatureFlag(
    FeatureFlag.downloadableIncidentVideos
  )

  const handlePlay = () => {
    dispatch(setVideoPlaying(true))
  }

  const handlePause = () => {
    dispatch(setVideoPlaying(false))
  }

  return (
    <ReactPlayer
      config={
        isDownloadEnabled
          ? undefined
          : {
              file: {
                attributes: {
                  // Disable download button in video controls
                  controlsList: 'nodownload',
                },
              },
            }
      }
      controls
      data-testid='incident-note-video-player'
      height={height}
      loop
      muted
      // Disable right-click context menu to prevent video download options when FF is false
      onContextMenu={isDownloadEnabled ? undefined : (e) => e.preventDefault()}
      onPause={handlePause}
      onPlay={handlePlay}
      playing={play}
      url={videoUrl}
      width={width}
    />
  )
}
